import React from "react";
import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";

interface OrgSwitchOverlayProps {
  organizationName: string;
}

const OrgSwitchOverlay: React.FC<OrgSwitchOverlayProps> = ({
  organizationName,
}) => (
  <Backdrop
    open
    sx={{
      color: "common.white",
      zIndex: (theme) => theme.zIndex.modal + 1,
      flexDirection: "column",
      gap: 2,
    }}
  >
    <CircularProgress color="inherit" size={40} />
    <Box sx={{ textAlign: "center", px: 3 }}>
      <Typography variant="h6" fontWeight={600}>
        Switching organization
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.9 }}>
        Loading {organizationName}…
      </Typography>
    </Box>
  </Backdrop>
);

export default OrgSwitchOverlay;
